var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewVersion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1133.000000, -1722.000000)",
    fill: "currentColor",
    id: "Icon/NewVersion"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1130.000000, 1721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4017963,11.4455446 C20.1680183,12.4731855 20.5891113,13.7206031 20.5891113,15.029082 C20.5891113,18.20438 18.1225408,20.8035797 15.0009087,21.0151721 L15,23.0225632 L12,20.0225632 L15,17.0225632 L15.0009088,19.0081429 C17.0165797,18.8020021 18.5891113,17.0991842 18.5891113,15.029082 C18.5891113,14.2425293 18.3624496,13.4924265 17.9447032,12.8507976 L17.798426,12.6410376 L19.4017963,11.4455446 Z M17,1 C18.1384277,1 19,1.93566895 19,3 L19,3 L19,7 L17,7 L17,3 L5,3 L5,19 L8.00494385,19 L8,21 L8,21 L4.99,21 C3.89,21 3,20.1 3,19 L3,19 L3,3 C3,1.9 3.9,1 5,1 L5,1 Z M14.0891113,7.00651872 L17.0891113,10.0065187 L14.0891113,13.0065187 L14.0892054,11.0208366 C12.0730533,11.2265151 10.5,12.9295544 10.5,15 C10.5,15.7865526 10.7266618,16.5366555 11.1444081,17.1782844 L11.2906853,17.3880443 L9.68731499,18.5835374 C8.92109302,17.5558964 8.5,16.3084789 8.5,15 C8.5,11.824419 10.9670101,9.22503904 14.0890372,9.01385339 L14.0891113,7.00651872 Z",
    id: "NewVersion"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVersion);
export default __webpack_public_path__ + "static/media/NewVersion.c7aad75c.svg";
export { ForwardRef as ReactComponent };